export const MINUTES_TRESHOLD_FOR_STALE_DATA = 5;
